<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="relative z-50" @close="$emit('decline')">
            <TransitionChild
                as="template"
                enter="ease-out duration-300"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="ease-in duration-200"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-gray-900/70 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <DialogPanel class="relative w-full max-w-xl transform overflow-hidden rounded-2xl bg-white px-8 pb-8 pt-10 text-center shadow-2xl transition-all sm:my-8 sm:px-10">
                            <button
                                type="button"
                                class="absolute right-5 top-5 text-gray-400 hover:text-gray-700 focus:outline-none"
                                @click="$emit('decline')"
                            >
                                <font-awesome-icon :icon="faXmark" class="h-5 w-5" />
                                <span class="sr-only">Close</span>
                            </button>

                            <DialogTitle as="h3" class="text-3xl font-bold tracking-tight text-rent-risk-blue-400">
                                Cut Application Fraud in Half
                            </DialogTitle>

                            <p class="mt-4 text-lg font-bold text-gray-900">with Verified Reports</p>

                            <ul class="mt-4 space-y-1 text-base text-gray-700">
                                <li>Asset Verification</li>
                                <li>Income Verification</li>
                                <li>Identity Verification</li>
                                <li>Employment Verification</li>
                            </ul>

                            <button
                                type="button"
                                :disabled="processing"
                                class="mt-8 inline-block rounded-md bg-rent-risk-blue-400 px-10 py-4 text-base font-bold tracking-wide text-white shadow-sm hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rent-risk-blue-400 disabled:cursor-not-allowed disabled:opacity-60"
                                @click="$emit('accept')"
                            >
                                {{ processing ? 'Processing...' : 'Request Verified Reports' }}
                            </button>

                            <button
                                type="button"
                                class="mx-auto mt-5 block text-sm text-rent-risk-blue-400 underline hover:text-rent-risk-blue-500"
                                @click="$emit('decline')"
                            >
                                No thanks, View Application
                            </button>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faXmark } from '@fortawesome/pro-solid-svg-icons'

// RAC-10337: shown when a landlord clicks "View Application". Accepting opens the
// existing Enhanced Screening options modal; declining continues to the
// application detail page.
defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    processing: {
        type: Boolean,
        default: false,
    },
})

defineEmits(['accept', 'decline'])
</script>
